import { render } from "./IntercomIcon.vue?vue&type=template&id=790df9a8"
import script from "./IntercomIcon.vue?vue&type=script&lang=ts"
export * from "./IntercomIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script